import { createSelector } from 'reselect'

const getCompetingInterviewRequests = state => state.views.candidateDetails_LEGACY.competingInterviewRequests.collection

export const competingInterviewRequests = createSelector(
  [getCompetingInterviewRequests],
  competingInterviewRequests => competingInterviewRequests,
)

export const hasCompetingInterviewRequests = createSelector(
  [competingInterviewRequests],
  competingInterviewRequests => competingInterviewRequests.length > 0,
)
